import { ClinicalTrialsParagraphContents } from "@EditArticleContainer/shared/types/paragraphContents/paragraphContents.types";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { useCreateClinicalResultsContent } from "./hooks/useCreateClinicalResultsContent";
import { useCreateClinicalTrialDesignContent } from "./hooks/useCreateClinicalTrialDesignContent";
import { useCreateDrugProfileContent } from "./hooks/useCreateDrugProfileContent";
import { useCreateKeyCommentsContent } from "./hooks/useCreateKeyCommentsContent";
import { useCreateTitleContent } from "./hooks/useCreateTitleContent";
import { useCreateTopicContent } from "./hooks/useCreateTopicContent";

export const useCreateClinicalTrialsContent = () => {
  const createClinicalResults = useCreateClinicalResultsContent();
  const createDrugProfile = useCreateDrugProfileContent();
  const createClinicalTrialDesign = useCreateClinicalTrialDesignContent();
  const createTitle = useCreateTitleContent();
  const createTopic = useCreateTopicContent();
  const createKeyComments = useCreateKeyCommentsContent();

  return async (): Promise<ClinicalTrialsParagraphContents> => {
    const title = createTitle();
    const topic = createTopic();
    const drugProfile = createDrugProfile();
    const clinicalTrialDesign = createClinicalTrialDesign();
    const clinicalResults = await createClinicalResults();
    const keyComments = createKeyComments();

    return {
      "Article Id": Number(getPressIdFromURL()),
      TC001: title,
      TC002: topic,
      TC003: drugProfile,
      TC004: clinicalTrialDesign,
      TC005: clinicalResults,
      TC006: keyComments,
    };
  };
};
